import classNames from "classnames"
import { Form, Link, useLoaderData, useNavigate } from "react-router-dom";
import { API_URL } from "../../lib/config";
import { Post } from "../../lib/post";
import { overrideQuery } from "../../lib/query"
import { range } from "../../lib/range"

import chevronLeft from  "../../assets/images/icons/chevron-back-outline.svg";
import chevronRight from "../../assets/images/icons/chevron-forward-outline.svg";

const NAV_PAGE_OFFSET = 3;

export async function loader({ request }: { request: Request }) {
    const url = new URL(request.url);

    const paramNames = ["search", "page"];
    const params = paramNames
        .filter(url.searchParams.has.bind(url.searchParams))
        .map((paramName) => [paramName, url.searchParams.get(paramName) || ""]);

    let data = {
        pagination: {
            page: 0,
            numPages: 0,
        },
        posts: [] as Post[],
    };
    try {
        const res = await fetch(
            API_URL + "/posts?" + new URLSearchParams(params)
        );

        data = await res.json();
    } catch (error) {
        console.error(error);
    }

    return {
        params: Object.fromEntries(params) as { [x: string]: string },
        data,
    };
}

export default function Blog() {
    const navigate = useNavigate()
    const { data, params } = useLoaderData() as Awaited<
        ReturnType<typeof loader>
    >;

    return (
        <div className="flex w-11/12 max-w-3xl flex-col gap-4">
            <div className="flex w-full items-center justify-between gap-4">
                <Form className="flex w-full max-w-sm rounded-full border border-xv-border-color bg-xv-bg-2">
                    <input
                        className="w-full rounded-full bg-transparent px-4 py-1.5"
                        placeholder="Pesquisar"
                        type="search"
                        name="search"
                    />
                    {params["search"] && (
                        <button
                            type="button"
                            className="px-4 py-1.5"
                            onClick={() =>
                                navigate(overrideQuery({ search: null }))
                            }
                        >
                            X
                        </button>
                    )}
                </Form>
            </div>

            <div>
                <div className="mb-2 grid grid-cols-2 gap-1 rounded-md border border-xv-border-color bg-xv-bg-2 px-6 py-2 md:grid-cols-posts">
                    <span className="overflow-hidden text-ellipsis whitespace-nowrap text-left">
                        Título
                    </span>
                    <span className="overflow-hidden text-ellipsis whitespace-nowrap text-left">
                        Criado em
                    </span>
                </div>

                {data.posts.map((post) => (
                    <Link
                        to={`/blog/${post.id}`}
                        key={post.id}
                        className="grid grid-cols-2 gap-1 border-x border-t border-xv-border-color py-2 px-6 last:border-b odd:bg-xv-bg-2 hocus:bg-xv-bg-2 hocus:brightness-75 md:grid-cols-posts"
                    >
                        <span
                            className="overflow-hidden text-ellipsis whitespace-nowrap"
                            title={post.title}
                        >
                            {post.title}
                        </span>
                        <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                            {new Date(post.createdAt).toLocaleDateString()}
                        </span>
                    </Link>
                ))}
            </div>

            {data.pagination.numPages > 1 && (
                <nav className="grid w-full place-items-center">
                    <ol className="flex gap-2">
                        {data.pagination.page > 0 && (
                            <li className="grid place-items-center">
                                <Link
                                    className="grid place-items-center"
                                    to={overrideQuery({
                                        page: (
                                            data.pagination.page - 1
                                        ).toString(),
                                    })}
                                >
                                    <img
                                        className="w-5"
                                        src={chevronLeft}
                                        alt="<"
                                    />
                                </Link>
                            </li>
                        )}
                        {data.pagination.page - NAV_PAGE_OFFSET > 0 && (
                            <>
                                <li>
                                    <Link to={overrideQuery({ page: "0" })}>
                                        1
                                    </Link>
                                </li>
                                <li> ... </li>
                            </>
                        )}

                        {range(
                            Math.max(0, data.pagination.page - NAV_PAGE_OFFSET),
                            Math.min(
                                data.pagination.numPages,
                                data.pagination.page + NAV_PAGE_OFFSET + 1
                            )
                        ).map((page) => {
                            return (
                                <li key={page}>
                                    <Link
                                        className={classNames({
                                            "border-b border-xv-red font-bold":
                                                data.pagination.page === page,
                                        })}
                                        to={overrideQuery({
                                            page: page.toString(),
                                        })}
                                    >
                                        {page + 1}
                                    </Link>
                                </li>
                            );
                        })}

                        {data.pagination.page + NAV_PAGE_OFFSET <
                            data.pagination.numPages - 1 && (
                            <>
                                <li> ... </li>
                                <li>
                                    <Link
                                        to={overrideQuery({
                                            page: (
                                                data.pagination.numPages - 1
                                            ).toString(),
                                        })}
                                    >
                                        {data.pagination.numPages}
                                    </Link>
                                </li>
                            </>
                        )}
                        {data.pagination.page + 1 <
                            data.pagination.numPages && (
                            <li className="grid place-items-center">
                                <Link
                                    className="grid place-items-center"
                                    to={overrideQuery({
                                        page: (
                                            data.pagination.page + 1
                                        ).toString(),
                                    })}
                                >
                                    <img
                                        className="w-5"
                                        src={chevronRight}
                                        alt=">"
                                    />
                                </Link>
                            </li>
                        )}
                    </ol>
                </nav>
            )}
        </div>
    );
}
